import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface TrialUsage {
  is_trial: boolean
  calls_used: number
  calls_limit: number
  calls_remaining: number
  minutes_used: number
  minutes_limit: number
  minutes_remaining: number
  is_unlimited: boolean
  limit_reached: boolean
  extension_requested: boolean
  extension_requested_at: string | null
}

/** GET /api/companies/{id}/trial-usage/ — usage essai (appels + minutes). */
export function useTrialUsage(companyId: number | undefined, enabled = true) {
  return useQuery({
    queryKey: ['trial-usage', companyId],
    queryFn: async () => {
      const { data } = await api.get<TrialUsage>(
        `/api/companies/${companyId}/trial-usage/`,
      )
      return data
    },
    enabled: !!companyId && enabled,
    staleTime: 30_000,
  })
}
